import { isEqual, omit } from 'lodash';
import QueryString from 'query-string';

export const shouldChangeV3BasedBranches = (initialSearch, currSearch) => {
  const currentSearch = QueryString.parse(currSearch, {
    ignoreQueryPrefix: true
  });
  const keysToOmit = ['page', 'pageSize', 'order_by', 'iteration_id'];

  return !isEqual(
    omit(currentSearch, keysToOmit),
    omit(initialSearch, keysToOmit)
  );
};
